import React, {Fragment} from 'react';
import {TextField} from 'material-ui';
import {Props} from '../Builder/ElementProperties';

const TextfieldElement = (props) => {

	let autoFocusClass = (!props.builder && props.element.autoFocus) ? 'auto-focus' : '';

	return (
		<TextField
			className={`textfield-element ${autoFocusClass}`}
			label={props.element.label}
			value={props.element.value || ''}
			onChange={ e => { 
				props.element.value = e.currentTarget.value;
				props.experiment.forceUpdate(); 
			}}
			onFocus={ e => {
				props.experiment.recordEvent({eventType:'User Action', actionType:'text input start', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'textinput', value: props.element.value, expectedValue: props.element.expected });
				props.experiment.forceUpdate();
			}}
			onBlur={ e => {
				props.experiment.recordEvent({eventType:'User Action', actionType:'text input submit', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'textinput', value: props.element.value, expectedValue: props.element.expected });
				props.experiment.forceUpdate();
			}}
			fullWidth
			multiline={+props.element.rows > 1}
			rows={props.element.rows || 1}
			/>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.Label {...props} />
		<Props.Expected {...props} />
		<Props.Rows {...props} />
		<Props.AutoFocus {...props} />
	</Fragment>
);

TextfieldElement.type = 'textfield';
TextfieldElement.Properties = Properties;
TextfieldElement.defaultJSON = {type: 'textfield', id:'New Textfield', x: 250, y:250, width:200, height:60, rows:1, label:'New Textfield', expected: '', autoFocus: false};
export default TextfieldElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/TextfieldElement.js